export default {
  gfb: {
    tourHint: 'Intro starten',
    keyboardInfoHint: 'Tastaturbedienung',
    autoEditHint: 'Automatisch editieren ein/aus',
    expandHint: 'Alle Gruppen ausklappen',
    collapseHint: 'Alle Gruppen einklappen',
    undoHint: 'Rückgängig machen',
    clearHint: 'Alle Bausteine entfernen',
    sortHint: 'Gruppen/Bausteine sortieren',
    selectHint: 'Alle Bausteine selektieren',
    createGroupHint: 'Bausteingruppe erstellen',
    exportHint: 'Bausteine exportieren',
    deleteHint: 'Bausteingruppe entfernen',
    ungroupHint: 'Bausteingruppe auflösen',
    saveHint: 'Bausteingruppe speichern',
    tplImport: 'Vorlage importieren',
    groupImport: 'Gruppe importieren',
    blockImport: 'Baustein importieren',
    blockSelect: 'Baustein selektieren',
    exists: 'vorhanden',
    draggable: 'Bausteingruppe verschieben',
    groups: {
      text: 'Texterfassung',
      predefined: 'Vordefiniert',
      select: 'Auswahl',
      range: 'Bereiche',
      header: 'Überschriften',
      userdefined: 'Benutzerdefiniert'
    },
    fields: {
      text: {
        label: 'Text',
        icon: 'mdi-form-textbox',
        hint: 'Einfacher einzeiliger Text'
      },
      textarea: {
        label: 'Mehrzeiliger Text',
        icon: 'mdi-text',
        hint: 'Texterfassung mit vorgegebener Anzahl von Zeilen'
      },
      number: {
        label: 'Nummer',
        icon: 'mdi-form-textbox',
        hint: 'Nummer'
      },
      autocomplete: {
        label: 'Autovervollständigung',
        icon: 'mdi-feature-search-outline'
      },
      button: {
        label: 'Knopf',
        icon: 'mdi-cursor-default-click'
      },
      checkbox: {
        label: 'Auswahlbox',
        icon: 'mdi-check-box-outline',
        hint: 'Dieser Baustein bietet die Möglichkeit eine Option zu aktivieren. Eine klassische Anwendung sind einfache Ja/Nein-Fragen.'
      },
      switch: {
        label: 'Auswahlschalter',
        icon: 'mdi-toggle-switch'
      },
      radio: {
        label: 'Auswahlliste',
        icon: 'mdi-radiobox-marked',
        hint: 'Auswahl aus einer Liste von Möglichkeiten'
      },
      combobox: {
        label: 'Mehrfachauswahl',
        icon: 'mdi-format-list-checks'
      },
      select: {
        label: 'Selektion',
        icon: 'mdi-arrow-down-drop-circle'
      },
      date: {
        label: 'Datum',
        icon: 'mdi-calendar'
      },
      time: {
        label: 'Uhrzeit',
        icon: 'mdi-clock'
      },
      password: {
        label: 'Passwort',
        icon: 'mdi-form-textbox-password'
      },
      phone: {
        label: 'Telefon',
        icon: 'mdi-phone'
      },
      email: {
        label: 'E-Mail',
        icon: 'mdi-email-outline'
      },
      slider: {
        label: 'Bereich',
        icon: 'mdi-ray-start-end',
        hint: 'Auswahl aus einem Wertebereich von Min bis Max'
      },
      range: {
        label: 'Von-bis Bereich',
        icon: 'mdi-ray-start-end',
        hint: 'Auswahl aus einem Wertebereich von ... bis'
      },
      rating: {
        label: '5 Sterne',
        icon: 'mdi-star',
        hint: 'Standard 5 Sterne Bewertung'
      },
      infotext: {
        label: 'Infotext',
        icon: 'mdi-comment',
        hint: 'Fest hinterlegter und nicht bearbeitbarer Text'
      },
      sparkline: {
        label: 'Diagramm',
        icon: 'mdi-chart-line',
        hint: 'Zeitlicher Verlauf von Werten'
      },
      spacer: {
        label: 'Platzhalter',
        icon: 'mdi-arrow-up-down-bold-outline',
        hint: 'Leeres Feld'
      },
      gap: {
        label: 'Absatz',
        icon: 'mdi-arrow-up-down-bold-outline',
        hint: ''
      },
      divider: {
        label: 'Zwischenüberschrift',
        icon: 'mdi-minus',
        hint: 'Überschrift mit Trennlinie'
      },
      subheader: {
        label: 'Überschrift',
        icon: 'mdi-page-layout-header',
        hint: 'Text für Gruppierung von Feldern'
      },
      note: {
        label: 'Schulnote',
        icon: 'mdi-music-note',
        hint: 'Vergabe einer Schulnote 1-6'
      },
      duration: {
        label: 'Dauer',
        icon: 'mdi-timer',
        hint: 'hh:mm:ss'
      },
      link: {
        label: 'Link',
        icon: 'mdi-link',
        hint: 'Verweis auf eine andere Seite'
      }
    },
    props: {
      name: {
        label: 'Name',
        hint: 'Name'
      },
      label: {
        label: 'Titel',
        hint: 'Der Titel des Bausteins'
      },
      hint: {
        label: 'Hilfetext',
        hint: 'Der Hilfetext unterhalb des Bausteins'
      },
      required: {
        label: 'Pflichtfeld?',
        hint: 'Eine Eingabe ist zwingend erforderlich'
      },
      readonly: {
        hint: 'Nur lesen?'
      },
      items: {
        hint: 'Auswahlmöglichkeiten. Auswahl anklicken zur Bearbeitung.'
      },
      multiple: {
        label: 'Mehrfachauswahl'
      },
      rows: {
        hint: 'Anzahl sichtbarer Zeilen'
      },
      min: {
        hint: 'Minimum'
      },
      max: {
        hint: 'Maximum'
      },
      row: {
        label: 'Horizontal anordnen?',
        hint: 'Die Auswahlmöglichkeiten können neben- oder untereinander angezeigt werden.'
      },
      step: {
        hint: 'Schrittweite'
      },
      customLabels: {
        hint: 'Individuelle Auswahlmöglichkeiten mit Komma getrennt erfassen'
      }
    },
    actions: {
      edit: 'Bearbeiten',
      clone: 'Duplizieren',
      export: 'Exportieren',
      delete: 'Entfernen'
    },
    field: {
      title: 'Baustein',
      editTitle: 'Baustein bearbeiten',
      export: 'Exportieren',
      exportHint: 'Baustein in Export berücksichtigen',
      requiredHint: 'Baustein ist ein Pflichtfeld',
      fieldtoggleHint: 'Bausteingruppe muß aktiviert werden'
    },
    block: {
      title: 'Bausteingruppe',
      editTitle: 'Bausteingruppe bearbeiten',
      deleteMessage: 'Bausteingruppe wirklich entfernen?',
      name: 'Name der Bausteingruppe',
      description: 'Beschreibung der Bausteingruppe',
      initials: 'Kürzel der Bausteingruppe',
      internal: 'Interne Verwendung',
      noRating: 'Ohne Bewertung',
      weighting: 'Gewichtung',
      weightingHint: 'Prozentsatz Gewichtung zur Berechnung',
      export: 'Exportieren',
      exportHint: 'Bausteingruppe in Export berücksichtigen',
      defaultName: 'Ohne Gruppe',
      defaultDescription: 'Bausteine ohne Gruppenzuordnung',
      activate: 'Aktivieren',
      activateHint: 'Bausteingruppe muß aktiviert werden',
      deactivate: 'Deaktivieren',
      deactivateHint: 'Bausteingruppe wirklich wieder deaktivieren?'
    },
    rating: {
      option: 'Auswahl',
      header: 'Auswahl bearbeiten',
      label: 'Bezeichnung',
      min: 'Minimale Punktzahl',
      max: 'Maximale Punktzahl',
      failed: 'Kann als "Durchgefallen" gekennzeichnet werden',
      exclude: 'Nicht bewerten',
      include: 'Bewertung wieder aktivieren',
      setmin: 'Minimale Bewertung setzen',
      setmax: 'Maximale Bewertung setzen',
      weighting: 'Gewichtung bearbeiten'
    },
    cloneblock: {
      title: 'Baustein hinzufügen',
      inGroup: 'In aktuelle Gruppe',
      atEnd: 'Am Ende einfügen'
    },
    sort: {
      first: 'An den Anfang verschieben',
      prev: 'Eine Position nach oben verschieben',
      next: 'Eine Position nach unten verschieben',
      last: 'An das Ende verschieben',
      expand: 'Gruppe ausklappen',
      collapse: 'Gruppe einklappen'
    },
    keyHandling: {
      home: {key: 'Pos 1', title: 'Fokus auf erste Gruppe setzen'},
      end: {key: 'Ende', title: 'Fokus auf letzte Gruppe setzen'},
      cursorUp: {key: 'Pfeil hoch', title: 'Fokus eine Gruppe nach oben wechseln'},
      cursorDown: {key: 'Pfeil runter', title: 'Fokus eine Gruppe nach unten wechseln'},
      ctrlHome: {key: 'Strg+Pos 1', title: 'Gruppe an Anfang verschieben'},
      ctrlEnd: {key: 'Strg+Ende', title: 'Gruppe ans Ende verschieben'},
      ctrlCursorUp: {key: 'Strg+Pfeil hoch', title: 'Gruppe nach oben verschieben'},
      ctrlCursorDown: {key: 'Strg+Pfeil runter', title: 'Gruppe nach unten verschieben'},
      cursorRight: {key: 'Pfeil rechts', title: 'Gruppe aufklappen'},
      cursorLeft: {key: 'Pfeil links', title: 'Gruppe zuklappen'},
      del: {key: 'Entf', title: 'Gruppe entfernen'}
    }
  }
}
